module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a13569c3e30663c32c142b5faf389957.png";